import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function workspaceIdReducer(state = initialState.workspaceId, action: any) {
  switch (action.type) {
    case types.SAVE_SUBSCRIPTION_ID_SUCCESS:
      return action.workspaceId;
    default:
      return state;
  }
}
